import { useContextState } from '../../../../../hooks/theme'

export const useStyles = () => {
  const { colors } = useContextState()

  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
      padding: '6px 4px',
    },
    header: {
      marginBottom: '20px',
      flexShrink: 0,
    },
    title: {
      fontSize: '18px',
      fontWeight: '600',
      color: colors.color13,
    },
    subtitle: {
      fontSize: '14px',
      color: colors.color10,
      marginTop: '4px',
    },
    columnsContainer: {
      display: 'flex',
      flex: 1,
      minHeight: 0,
      gap: '20px',
      overflow: 'hidden',
    },
    filterButton: {
      backgroundColor: colors.color31,
      color: colors.color5,
      borderRadius: '4px',
      padding: '6px',
      '&:hover': {
        backgroundColor: `${colors.color31}99`,
      },
      '& svg': {
        color: colors.color5,
      },
    },
    filterModalContainer: {
      padding: '50px 60px',
      minWidth: '400px',
      position: 'relative',
    },
    filterModalHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '20px',
      position: 'relative',
    },
    filterModalTitle: {
      fontSize: '22px',
      fontWeight: '600',
      color: colors.color9,
    },
    filterModalClose: {
      position: 'absolute',
      top: '-35px',
      right: '-50px',
      '&.MuiSvgIcon-root': {
        fontSize: '2rem',
      },
    },
    filterModalButton: {
      marginTop: '20px',
      backgroundColor: colors.color8,
      color: colors.color5,
      fontWeight: '500',
      padding: '5px 20px',
      '&:hover': {
        backgroundColor: `${colors.color8}ee`,
      },
    },
  }
}
